import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";


/**
 *
 * @param {*} param
 * @param {string} param.networkID
 * @returns {Promise<any>}
 */
export const getSignupsList = async () => {
  const endpoint = "/signuplist/list";
  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};